import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { PropsWithChildren, ReactElement } from 'react';
import Actions, { Action } from '../../layout/actions';

export interface Props {
  title: string;
  actions?: Action[];
}

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 10,
    padding: '0 20px !important',
    [theme.breakpoints.up('xs')]: {
      padding: 0,
      marginBottom: 25,
    },
    '& h2': {
      [theme.breakpoints.down('xs')]: {
        fontSize: '22px',
        lineHeight: '40px',
      },
    },
    '@media print': {
      display: 'none',
    },
  },
}));

export function Listing({
  title,
  children,
  actions,
}: PropsWithChildren<Props>): ReactElement {
  const classes = useStyles();
  return (
    <>
      <div className={classes.header}>
        <Typography variant='h2'>{title}</Typography>
        {actions && <Actions actions={actions} />}
      </div>
      {children}
    </>
  );
}
